import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';

const DRAWER_WIDTH = 360;
const MARGIN = 20;

const DrawerToggleButton = ({ open, onToggle, errorsCount = 0, warningsCount = 0 }) => {
  const hasErrors = errorsCount > 0;
  const hasWarnings = warningsCount > 0;

  const getColor = (theme) => {
    if (hasErrors) return theme.palette.error.main;
    if (hasWarnings) return theme.palette.warning.main;
    return theme.palette.primary.main;
  };

  const tooltipText = hasErrors
    ? `${errorsCount} error(es) detectado(s)`
    : hasWarnings
    ? `${warningsCount} advertencia(s) detectada(s)`
    : 'No hay notificaciones';

  return (
    <Tooltip title={tooltipText}>
      <IconButton
        onClick={onToggle}
        sx={{
          position: 'fixed',
          top: '90px',
          right: open ? DRAWER_WIDTH + MARGIN : MARGIN,
          zIndex: 1300,
          transition: 'right 0.3s ease',
          backgroundColor: 'white',
          borderRadius: '50%',
          boxShadow: 3,
          animation: hasErrors || hasWarnings ? 'pulse 1.5s infinite' : 'none',
          '&:hover': {
            backgroundColor: '#f5f5f5',
            transform: 'scale(1.2)',
          },
          '@keyframes pulse': {
            '0%': { transform: 'scale(1)' },
            '50%': { transform: 'scale(1.1)' },
            '100%': { transform: 'scale(1)' },
          },
        }}
      >
        <NotificationsIcon sx={{ fontSize: '2.5rem', color: getColor }} />
      </IconButton>
    </Tooltip>
  );
};

export default DrawerToggleButton;